import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AbstractAttributeInputComponent } from '../abstract-attribute-input-component';

@Component({
  selector: 'h3-text-attribute-input',
  templateUrl: './text-attribute-input.component.html',
  styleUrls: ['../abstract-attribute-input-component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TextAttributeInputComponent
  extends AbstractAttributeInputComponent
  implements OnInit
{
  @ViewChild('inputArea', { static: false }) inputArea!: ElementRef;

  override ngOnInit() {
    super.ngOnInit();
    this.subscribeTo(this.form.controls.input.valueChanges, (value) => {
      this.setAttribute(value);
    });
  }

  focusIn() {
    this.isFocused = true;
    setTimeout(() => {
      this.inputArea.nativeElement.focus();
    }, 0);
  }

  onKeyPress($event: KeyboardEvent) {
    if ($event.code === 'Enter') {
      $event.preventDefault();
      this.closeAndSave();
    }
  }

  focusOut() {
    this.closeAndSave();
  }
}
